<template>
  <el-dialog :title="$t('nova-mensagem')" :visible.sync="dialog" :fullscreen="true">
    <MessageAddUsers :userType="userType" ref="addUsers" @add="add" />
    <el-form :model="ruleForm" ref="ruleForm" label-position="right" label-width="120px">
      <el-form-item :label="$t('Para')" prop="to">
        <el-row>
          <el-col :span="20">
            <el-select v-model="ruleForm.to" multiple placeholder="Usuários">
              <el-option v-for="row of userList" :key="row.value" :label="row.label" :value="row.value"></el-option>
            </el-select>
          </el-col>
          <el-col :span="4">
            <el-button @click="$refs.addUsers.open()" type="warning">Selecionar</el-button>
          </el-col>
        </el-row>
      </el-form-item>
      <el-form-item :label="$t('assunto')" prop="subject">
        <el-input type="text" placeholder="Assunto" v-model="ruleForm.subject" maxlength="40" show-word-limit>
        </el-input>
      </el-form-item>
      <el-form-item prop="highlight">
        <el-checkbox v-model="ruleForm.highlight" style="margin-bottom: 20px">Destacar na página inicial</el-checkbox>
      </el-form-item>
    </el-form>
    <vue-editor ref="vEditor" v-model="ruleForm.message"></vue-editor>
    <span slot="footer" class="dialog-footer">
      <el-button @click="toggle">{{ $t('cancelar') }}</el-button>
      <el-button type="primary" @click="sendMessage">Enviar mensagem</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { VueEditor } from "vue2-editor";
import { NotificationService } from "@/services/comum/notification.services";
import MessageAddUsers from "./MessageAddUsers.vue";

export default {
  components: { VueEditor, MessageAddUsers },
  props: ["userType"],
  data: function () {
    return {
      ruleForm: {
        id: null,
        sendedBy: '',
        to: [],
        subject: '',
        message: "",
        highlight: false,
      },
      userList: [],
      dialog: false,
      users: false,
    };
  },
  methods: {
    open(data) {
      if (data) {
        this.ruleForm.id = data.id;
        this.ruleForm.sendedBy = data.userName;
        this.ruleForm.subject = data.subject;
        this.ruleForm.message = data.messageHtml;
      }
      this.dialog = true;
    },
    toggle() {
      this.ruleForm.id = '';
      this.ruleForm.sendedBy = '';
      this.ruleForm.subject = '';
      this.ruleForm.message = '';
      this.ruleForm.to = [];
      this.userList = [];
      this.dialog = false;
    },
    duplicates(list) {
      const vm = this;
      return list.filter((x) => vm.userList.findIndex(y => y.value === x.value) === -1);
    },
    add(list) {
      const toAdd = this.duplicates(list);
      this.userList.push(...toAdd)
      this.ruleForm.to.push(...list.map(x => x.value));
    },
    async sendMessage() {
      const vm = this;
      if (vm.ruleForm.to && vm.ruleForm.to.length === 0) {
        return this.$message.error("Selecione ao menos um usuário");
      }

      const to = vm.ruleForm.to.map(x => {
        const userData = vm.userList.find(y => y.value === x)
        return {
          type: userData.type,
          value: userData.value,
        }
      });
      const loading = vm.$loading(vm.$options.loading);
      NotificationService.add(to, vm.ruleForm.subject, vm.ruleForm.message, this.$refs.vEditor.quill.getText(), vm.ruleForm.highlight)
        .then((response) => {
          this.$message({
            type: "success",
            duration: 5000,
            message: "Mensagem enviada com sucesso!",
          });
          vm.toggle();
        })
        .catch((error) => {
          this.$message({
            type: "error",
            duration: 5000,
            message: error,
          });
        })
        .finally(() => loading.close());

      this.$emit("onSend", { title: this.title, message: this.message });
      this.$emit("closeModal");
    },
  },
};
</script>